import React from "react"
import { FiCamera, FiMapPin, FiMessageCircle } from "react-icons/fi"
import SignInPage from "../core/auth/SignInPage"
import { dsignin, dauthenticate } from "../auth/helper/driverIndex"

const brand = {
    eyebrow: "Driver app",
    title: "Your whole day, one swipe at a time.",
    text: "Accept jobs, snap your tickets and message dispatch — arrivals check in on their own.",
    highlights: [
        { icon: FiMapPin, label: "Automatic arrival" },
        { icon: FiCamera, label: "Snap the ticket" },
        { icon: FiMessageCircle, label: "Chat with dispatch" },
    ],
}

const DriverSignin = () => (
    <SignInPage
        role="driver"
        roleLabel="Driver"
        bannerRole="driver"
        brand={brand}
        title="Welcome back"
        subtitle="Sign in to see today's jobs."
        signin={dsignin}
        authenticate={dauthenticate}
        redirectTo={data => (data.driver?.appVersion === "v1" ? "/driver/dashboard" : "/driver/app")}
        forgotPath="/driver/resetpassword"
        help={<>New driver? Use the username and temporary password your dispatcher gave you.</>}
    />
)

export default DriverSignin
